import type { Messages } from "./en";
export const es: Messages = {
  "meta.title": "ArtLove365 - Pinturas al óleo pintadas a mano",
  "meta.description": "Reproducciones al óleo pintadas a mano de las mayores obras maestras del mundo y retratos al óleo personalizados a partir de tus fotos.",
  "nav.gallery": "Galería",
  "nav.artists": "Artistas",
  "nav.custom": "Pinta mi foto",
  "nav.track": "Seguir pedido",
  "home.eyebrow": "Pintado a mano al óleo por artistas reales",
  "home.title": "Obras maestras para tus paredes. Tus recuerdos, pintados como obras maestras.",
  "home.subtitle": "Elige entre las pinturas más queridas de la historia o sube tu propia foto. Nuestros artistas la pintan a mano sobre lienzo y te la enviamos a casa.",
  "home.ctaGallery": "Ver la galería",
  "home.ctaCustom": "Subir una foto",
  "home.stepsTitle": "Cómo funciona",
  "home.step1Title": "Elige o sube",
  "home.step1Body": "Elige una obra maestra o sube una foto de tu familia, tu mascota o tu lugar favorito.",
  "home.step2Title": "La pintamos",
  "home.step2Body": "Un pintor profesional trabaja sobre lienzo real. En los pedidos personalizados apruebas primero un boceto.",
  "home.step3Title": "Te la enviamos",
  "home.step3Body": "Tras el secado, tu cuadro se embala con cuidado y se envía a todo el mundo con seguimiento.",
  "home.featured": "Obras destacadas",
  "gallery.title": "Galería de obras maestras",
  "gallery.subtitle": "Cada cuadro se reproduce a mano al óleo sobre lienzo, nunca impreso.",
  "gallery.filterAll": "Todos los artistas",
  "gallery.empty": "No se encontraron cuadros.",
  "artists.title": "Los maestros",
  "artists.works": "Ver obras",
  "artwork.by": "de",
  "artwork.order": "Encargar este cuadro",
  "artwork.notFound": "No se encontró este cuadro.",
  "order.size": "Tamaño del lienzo",
  "order.frame": "Acabado",
  "frame.rolled": "Lienzo enrollado (en tubo)",
  "frame.stretched": "Montado en bastidor, listo para colgar",
  "frame.framed": "Bastidor + marco de madera",
  "order.subjects": "Personas o mascotas en la foto",
  "order.price.base": "Cuadro",
  "order.price.frame": "Acabado",
  "order.price.custom": "Retrato personalizado",
  "order.price.shipping": "Envío",
  "order.price.free": "Gratis",
  "order.price.total": "Total",
  "order.contact": "Datos de envío",
  "order.name": "Nombre completo",
  "order.email": "Correo electrónico",
  "order.phone": "Teléfono",
  "order.address": "Dirección",
  "order.city": "Ciudad",
  "order.postalCode": "Código postal",
  "order.country": "País",
  "order.notes": "Notas para el artista (opcional)",
  "order.submit": "Continuar al pago",
  "order.submitting": "Realizando tu pedido…",
  "order.error": "Algo salió mal. Revisa el formulario e inténtalo de nuevo.",
  "order.leadTime": "La pintura tarda 2-3 semanas más 1 semana de secado antes del envío.",
  "custom.title": "Convierte tu foto en una pintura al óleo",
  "custom.subtitle": "Sube una foto nítida y bien iluminada. Nuestros artistas la pintarán a mano, y tú apruebas el boceto antes de empezar.",
  "custom.upload": "Elegir una foto",
  "custom.uploadHint": "JPG, PNG o WebP, hasta 20 MB. Mayor resolución, mejor resultado.",
  "custom.uploading": "Subiendo…",
  "custom.uploaded": "Foto subida",
  "custom.replace": "Usar otra foto",
  "custom.style": "Estilo de pintura",
  "custom.style.classic": "Realismo clásico",
  "custom.style.impressionist": "Impresionista (como Monet)",
  "custom.style.vangogh": "Pincelada expresiva (como Van Gogh)",
  "custom.style.modern": "Moderno, paleta suave",
  "custom.needPhoto": "Primero sube una foto.",
  "track.title": "Sigue tu pedido",
  "track.code": "Código de pedido",
  "track.submit": "Buscar pedido",
  "track.notFound": "No encontramos ningún pedido con ese código y correo.",
  "track.placed": "Realizado el",
  "success.title": "¡Gracias! Tu pedido se ha realizado.",
  "success.body": "Te hemos enviado una confirmación por correo. Guarda tu código de pedido para seguir su progreso.",
  "status.awaiting_payment": "Pendiente de pago",
  "status.paid": "Pagado",
  "status.sketching": "Boceto",
  "status.painting": "Pintando",
  "status.drying": "Secando",
  "status.shipped": "Enviado",
  "status.delivered": "Entregado",
  "status.cancelled": "Cancelado",
  "common.loading": "Cargando…",
  "common.back": "Volver",
  "footer.tagline": "Pinturas al óleo hechas a mano, con envío a todo el mundo.",
  "footer.follow": "Síguenos",
  "footer.docs": "Ayuda y documentación",
  "gallery.search": "Buscar cuadros o artistas…",
  "sketch.title": "Tu boceto está listo",
  "sketch.body": "Revisa la composición. Solo empezamos a pintar cuando lo apruebes.",
  "sketch.approve": "Aprobar boceto",
  "sketch.change": "Pedir cambios",
  "sketch.feedback": "¿Qué debemos cambiar?",
  "sketch.send": "Enviar comentarios",
  "sketch.approved": "Boceto aprobado: ya hemos empezado a pintar.",
  "sketch.changesSent": "¡Gracias! El artista te enviará un boceto revisado.",
  "checkout.title": "Pago",
  "checkout.demoBanner": "Modo demostración: el pago en línea aún no está activo. No se cobrará nada ni se recogen datos de tarjeta.",
  "checkout.summary": "Resumen del pedido",
  "checkout.method": "Método de pago",
  "checkout.method.card": "Tarjeta de crédito / débito",
  "checkout.method.paypal": "PayPal",
  "checkout.method.wallet": "Apple Pay / Google Pay",
  "checkout.method.bank": "Transferencia bancaria",
  "checkout.cardNumber": "Número de tarjeta",
  "checkout.expiry": "Caducidad (MM/AA)",
  "checkout.cvc": "CVC",
  "checkout.cardName": "Titular de la tarjeta",
  "checkout.paypalNote": "Te redirigiremos a PayPal para aprobar el pago.",
  "checkout.walletNote": "Confirma con Face ID, Touch ID o tu teléfono.",
  "checkout.bankNote": "Te enviaremos nuestros datos bancarios por correo. Tu pedido empieza al recibir la transferencia (1-3 días hábiles).",
  "checkout.pay": "Pagar {amount}",
  "checkout.processing": "Procesando el pago…",
  "checkout.secure": "Los pagos están cifrados y los gestiona nuestro proveedor de pagos. Nunca guardamos números de tarjeta.",
  "checkout.demoDoneTitle": "Pago simulado",
  "checkout.demoDoneBody": "Esto fue una demostración: no se ha cobrado nada. Tu pedido está guardado y sigue «Pendiente de pago»; nuestro equipo te contactará para completar el pago.",
  "checkout.failTitle": "Pago rechazado",
  "checkout.failBody": "Tu banco rechazó el pago. Revisa los datos o prueba otro método.",
  "checkout.retry": "Intentar de nuevo",
  "checkout.viewOrder": "Ver mi pedido",
  "track.payNow": "Pagar ahora",
  "browse.title": "Explorar",
  "browse.movements": "Movimientos artísticos",
  "browse.museums": "Museos",
  "browse.subjects": "Temas",
  "browse.genres": "Géneros",
  "artwork.year": "Año",
  "artwork.size": "Tamaño original",
  "artwork.museum": "Museo",
  "artwork.movement": "Movimiento",
  "artwork.genre": "Género",
  "artwork.subjects": "Temas",
  "artwork.moreBy": "Más obras de",
  "pager.prev": "Anterior",
  "pager.next": "Siguiente",
  "count.paintings": "{n} pinturas",
  "fav.add": "Añadir a favoritos",
  "fav.remove": "Quitar de favoritos",
  "fav.title": "Mis favoritos",
  "fav.empty": "Aún no tienes favoritos. Toca el corazón en cualquier cuadro que te guste y te esperará aquí.",
  "fav.emptyCta": "Explorar la galería",
  "fav.syncHint": "Inicia sesión con Google para conservar tus favoritos en todos tus dispositivos.",
  "fav.saved": "Guardado en favoritos",
  "fav.nav": "Favoritos",
  "account.signIn": "Iniciar sesión",
  "account.signOut": "Cerrar sesión",
  "account.signedInAs": "Sesión iniciada como",
  "account.signInTitle": "Inicia sesión en ArtLove365",
  "viewer.open": "Ver a pantalla completa",
  "viewer.close": "Cerrar",
  "viewer.hint": "Desplaza o pellizca para ampliar · arrastra para explorar · doble clic para restablecer",
  "share.button": "Compartir",
  "share.copied": "Enlace copiado",
  "artwork.story": "Sobre este cuadro",
  "artwork.details": "Detalles",
  "artwork.aboutArtist": "Sobre el artista",
  "artwork.readArtist": "Descubre la vida de {name}",
  "artwork.relatedArtists": "Obras de artistas relacionados",
  "rel.influenced_by": "Inspiró a {artist}",
  "rel.influenced": "Inspirado por {artist}",
  "rel.student_of": "Maestro de {artist}",
  "rel.student": "Alumno de {artist}",
  "rel.movement": "También {movement}",
  "story.didYouKnow": "¿Sabías que…?",
  "story.sources": "Fuentes",
  "story.aiNote": "Redactado con ayuda de IA a partir de las fuentes indicadas. ¿Has visto un error? Avísanos.",
  "artist.relatedArtists": "Artistas relacionados",
  "artist.worksBy": "Obras de {name}",
  "nav.how": "Cómo trabajamos",
  "home.ctaArtists": "Conoce a los artistas",
  "home.discover": "Conócenos",
  "home.howCardTitle": "Cómo trabajamos",
  "home.howCardBody": "Pintores de verdad, lienzo de verdad, óleo y paciencia. Descubre cómo se recrea a mano una obra maestra.",
  "home.customCardTitle": "Tu foto, pintada al óleo",
  "home.customCardBody": "Familia, parejas, mascotas, la casa donde creciste: mira cómo convertimos una foto en un cuadro.",
  "home.featuredArtists": "Conoce a los maestros",
  "home.browseMovements": "Explora por movimiento",
  "common.readMore": "Leer más",
  "how.title": "Cómo trabajamos",
  "how.intro": "Cada cuadro de ArtLove365 se pinta a mano, con óleo sobre lienzo auténtico, por pintores profesionales. Sin impresión ni atajos. Esto es lo que ocurre entre una obra maestra y tu pared.",
  "how.s1t": "Empieza con un cuadro que te emociona",
  "how.s1b": "Explora miles de obras maestras, lee sus historias y guarda en favoritos las que te conmueven.",
  "how.s2t": "Un pintor estudia el original",
  "how.s2b": "Antes de la primera pincelada, el pintor estudia la composición, el color y cómo aplicaba la pintura el maestro: el orden de las capas importa tanto como los colores.",
  "how.s3t": "Pintado a mano, capa a capa",
  "how.s3b": "El óleo se construye despacio: una imprimación, las masas principales y después los detalles y veladuras. Un lienzo mediano requiere de dos a tres semanas de trabajo.",
  "how.s4t": "Revisado y puesto a secar",
  "how.s4b": "Un pintor sénior compara el lienzo con el original. Después, el óleo necesita alrededor de una semana para secarse antes de viajar con seguridad.",
  "how.s5t": "Embalado con cuidado, enviado a todo el mundo",
  "how.s5b": "Los cuadros viajan enrollados en un tubo rígido o montados en una caja reforzada, con seguimiento hasta tu puerta.",
  "how.materialsTitle": "Materiales",
  "how.materialsBody": "Óleos de calidad profesional, lienzo de algodón o lino imprimado y barniz que protege la superficie durante décadas.",
  "how.customTitle": "Pintar a partir de tu propia foto",
  "how.customBody": "En retratos y escenas personales añadimos un paso: apruebas un boceto de la composición antes de empezar a pintar.",
  "custom.pageTitle": "Pinturas al óleo personalizadas a partir de tus fotos",
  "custom.pageIntro": "Una foto guarda un momento. Un cuadro lo hace perdurar. Nuestros pintores convierten tus fotos en retratos y escenas al óleo pintados a mano, en el estilo que elijas.",
  "custom.howTitle": "Cómo funciona",
  "custom.step1t": "Compartes una foto",
  "custom.step1b": "Basta con una foto nítida; también podemos combinar varias en una sola escena.",
  "custom.step2t": "Apruebas un boceto",
  "custom.step2b": "Nuestro pintor prepara la composición. No se pinta nada hasta que estés contento.",
  "custom.step3t": "Lo pintamos a mano",
  "custom.step3b": "Óleo sobre lienzo, capa a capa, en el estilo que elegiste.",
  "custom.step4t": "Llega a casa",
  "custom.step4b": "Tras el secado y una revisión final, tu cuadro se embala y se envía con seguimiento.",
  "custom.stylesTitle": "Elige un estilo",
  "custom.styleDesc.classic": "Parecido fiel, luz suave y detalle fino, en la tradición de los grandes maestros.",
  "custom.styleDesc.impressionist": "Luz y atmósfera en toques sueltos y vibrantes, como una tarde de verano de Monet.",
  "custom.styleDesc.vangogh": "Pincelada gruesa y arremolinada, y color intenso, inspirados en Van Gogh.",
  "custom.styleDesc.modern": "Formas limpias y una paleta suave y actual que encaja en interiores modernos.",
  "custom.occasionsTitle": "Ideal para",
  "custom.occ.family": "Retratos de familia",
  "custom.occ.couples": "Parejas y bodas",
  "custom.occ.pets": "Mascotas",
  "custom.occ.children": "Niños",
  "custom.occ.memorial": "En memoria",
  "custom.occ.home": "Casas y lugares",
  "custom.tipsTitle": "Cómo elegir una buena foto",
  "custom.tip1": "Bien enfocada, sobre todo los ojos.",
  "custom.tip2": "Luz de día suave; evita el flash fuerte y los filtros.",
  "custom.tip3": "Caras lo bastante grandes para ver bien las expresiones.",
  "custom.tip4": "¿Varias fotos? Podemos reunir personas o mascotas en un solo cuadro.",
  "custom.explore": "Explora estilos en la galería",
  "showcase.title": "Encargos que hemos pintado",
  "showcase.subtitle": "Cuadros reales pintados para nuestros clientes, publicados con su permiso.",
  "showcase.all": "Todos",
  "custom.occ.nail": "Decoración para salones de uñas",
  "custom.occ.other": "Otros",
  "home.newTitle": "Historias recién contadas",
  "home.newWhy": "Los últimos cuadros con su historia completa: algo nuevo cada día.",
  "home.gemsTitle": "Joyas ocultas",
  "home.gemsWhy": "Menos famosos, igual de conmovedores. Cuadros ante los que casi todos pasan de largo - y no deberían.",
  "taxon.faqTitle": "¿Te preguntas qué es {name}?",
  "notFound.title": "Página no encontrada",
};
